<template>
  <div>
    <div v-if="loading">
      <Loading :center="false" />
    </div>

    <div v-else>
      <b-row>
        <b-col sm="5">
          <InputText title="Assunto" field="subject" :formName="formName" :required="true" :maxLength="100"
            v-model="job.subject" />
        </b-col>

        <b-col sm="7">
          <div class="loc-row" role="group" aria-label="Local">
            <div class="loc-input">
              <InputAddressGoogle v-if="isGoogleMaps" title="Local Google" field="address" :maxLength="200"
                v-model="job.location" />
              <InputText v-else title="Local" field="address" :maxLength="200" v-model="job.location" />
            </div>

            <div class="loc-toggle" role="radiogroup" aria-label="Modo de endereço">
              <button type="button" class="loc-icon" :class="{ active: isGoogleMaps }" role="radio"
                :aria-checked="isGoogleMaps ? 'true' : 'false'" @click="isGoogleMaps = true" title="Google Maps">
                <i class="fa-solid fa-map-location-dot icon-place" aria-hidden="true"></i>
                <span class="sr-only">Google Maps</span>
              </button>

              <button type="button" class="loc-icon" :class="{ active: !isGoogleMaps }" role="radio"
                :aria-checked="!isGoogleMaps ? 'true' : 'false'" @click="isGoogleMaps = false" title="Livre">
                <i class="fa-solid fa-location-dot icon-place" aria-hidden="true"></i>
                <span class="sr-only">Livre</span>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-tabs v-model="tabIndex">
        <b-tab title="Principal">
          <CheckboxSimple title="Dia Inteiro" v-model="job.allDay" />
          <b-row>
            <b-col sm="3">
              <DateTime title="Data Inicio" field="birthDate" format="DD/MM/YYYY" type="date" :required="true"
                placeholder :formName="formName" v-model="job.dateStart" />
            </b-col>
            <b-col sm="2" v-if="!job.allDay">
              <DateTime title="Hora" field="birthDate" format="HH:mm" type="time" placeholder :formName="formName"
                v-model="job.timeStart" />
            </b-col>
            <b-col sm="3">
              <DateTime title="Data Fim" field="birthDate" format="DD/MM/YYYY" type="date" :required="true" placeholder
                :formName="formName" v-model="job.dateEnd" />
            </b-col>
            <b-col sm="2" v-if="!job.allDay">
              <DateTime title="Hora" field="birthDate" format="HH:mm" type="time" placeholder :formName="formName"
                v-model="job.timeEnd" />
            </b-col>
          </b-row>

          <span class="title">Descrição</span>
          <ScrollBar :minHeight="150" :maxHeight="250">
            <EditorHtml field="description" :maxLength="5000" v-model="job.description" />
            <br />
          </ScrollBar>
        </b-tab>

        <b-tab title="Nota" v-if="job.id">
          <NoteListCreateEdit :jobId="job.id" />
        </b-tab>

        <b-tab title="Participantes">
          <b-row>
            <b-col sm="6">
              <Select title="Usuário Interno" :showNewRegister="false" field="user" :url="urlUser"
                v-model="selectUser" />
            </b-col>
            <b-col sm="4">
              <div class="side-by-side">
                <div class="btn-add">
                  <Button _key="btnAddUser" type="primary" :disabled="!selectUser.id" classIcon="fa-solid fa-plus"
                    size="small" :clicked="addUser" />
                </div>
              </div>
              <div class="side-by-side">
                <div class="btn-add">
                  <Button _key="btnAddAllUser" title="Todos" type="primary" classIcon="fa-solid fa-users" size="small"
                    :clicked="addAllUser" />
                </div>
              </div>
            </b-col>
          </b-row>

          <InputTag title="Participantes" placeholder="Digite um e-mail e pressione Enter" :initialValue="job.guest"
            v-model="job.guest" />
        </b-tab>

        <b-tab title="Anexo" v-if="job.id">
          <FileManager :showInModal="false" source="job" :genericId="job.id" />
        </b-tab>

        <b-tab title="Auditoria" v-if="job.id && (userLogged.user.userName === 'UserTemp' || hasRule('Audit'))">
          <ScrollBar :minHeight="300" :maxHeight="300">
            <TimelineLog v-if="tabIndex == 4" :id="job.id" />
          </ScrollBar>
        </b-tab>
      </b-tabs>

      <b-row>
        <b-col sm="12">
          <footer class="g-actions" aria-label="Ações">
            <div class="g-actions-left">
              <CheckboxSimple title="Marcar como concluída" v-model="job.done" />
              <CheckboxSimple v-if="job.id && job.guest.length > 0" :markFormDirty="false"
                title="Notificar Participantes" v-model="notify" />
            </div>

            <div class="g-actions-right">
              <CheckboxSimple title="Fechar ao salvar" :markFormDirty="false" v-model="closeOnSave" />
              <Button _key="create" type="success" title="Salvar" :disabled="!isFormValid(formName) || loadingBtn"
                classIcon="fas fa-save" size="medium" :clicked="create" />
            </div>
          </footer>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import EditorHtml from "@nixweb/nixloc-ui/src/component/forms/EditorHtml";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import InputAddressGoogle from "@nixweb/nixloc-ui/src/component/forms/InputAddressGoogle";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import InputTag from "@nixweb/nixloc-ui/src/component/forms/InputTag";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import FileManager from "@nixweb/nixloc-ui/src/component/shared/file-manager/FileManager";
import NoteListCreateEdit from "../note/NoteListCreateEdit.vue";
import TimelineLog from "../../adm/audit-log/TimelineLog.vue";

import Job from "@/components/modules/shared/job/Job.js";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "JobCreateUpdate",
  components: {
    Button,
    InputText,
    DateTime,
    EditorHtml,
    ScrollBar,
    InputAddressGoogle,
    CheckboxSimple,
    Loading,
    InputTag,
    Select,
    FileManager,
    NoteListCreateEdit,
    TimelineLog,
  },
  data() {
    return {
      formName: "jobCreateUpdate",
      job: new Job(),
      urlCreate: "/api/v1/shared/job/create",
      urlUpdate: "/api/v1/shared/job/update",
      urlUser: "/api/v1/adm/user/select-all",
      selectUser: {},
      isGoogleMaps: true,
      loading: true,
      loadingBtn: false,
      notify: false,
      closeOnSave: true,
      baseParams: {
        search: "",
        currentPage: 1,
        totalPerPage: 200,
      },
      tabIndex: 0,
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi", "getApi"]),
    ...mapMutations("validation", ["resetValidation"]),
    ...mapMutations("generic", ["addEvent", "removeLoading", "removeEvent", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    create() {
      this.loadingBtn = true;
      this.job.userId = this.userLogged.user.id;
      this.job.organizerName = this.userLogged.user.name;
      this.job.organizerEmail = this.userLogged.user.email;
      this.job.notify = this.notify;

      if (this.job.id) {
        const params = { url: this.urlUpdate, obj: this.job };
        this.putApi(params).then((response) => {
          if (response.success) {
            if (response.content && response.content.id) this.job.id = response.content.id;
            if (!this.closeOnSave) this.tabIndex = 1;
            if (this.closeOnSave) this.hideModal();
          }
          this.addEvent({ name: "updatedJob" });
          this.removeLoading(["create"]);
          this.loadingBtn = false;
        });
      } else {
        const params = { url: this.urlCreate, obj: this.job };
        this.postApi(params).then((response) => {
          if (response.success) {
            if (response.content && response.content.id) this.job.id = response.content.id;
            if (!this.closeOnSave) this.tabIndex = 1;
            if (this.closeOnSave) this.hideModal();
          }
          this.addEvent({ name: "updatedJob" });
          this.removeLoading(["create"]);
          this.loadingBtn = false;
        });
      }
    },
    update(data) {
      this.job = new Job();
      this.job.update(data);
      this.removeLoading([data.id]);
    },
    addUser() {
      if (!this.job.guest.includes(this.selectUser.content)) {
        this.job.guest.push(this.selectUser.content);
        this.selectUser = {};
      }
      this.removeLoading(["btnAddUser"]);
    },
    addAllUser() {
      const obj = { ...this.baseParams };
      const params = { url: this.urlUser, obj: obj };
      this.getApi(params).then((response) => {
        let self = this;
        response.content.data.forEach((user) => {
          if (!self.job.guest.includes(user.content)) {
            self.job.guest.push(user.content);
          }
        });
        this.removeLoading(["btnAddAllUser"]);
      });
    },
    removerDuplicados(array) {
      return array.filter((element, index) => array.indexOf(element) === index);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "jobUpdate") {
          this.update(event.data);
          this.loading = false;
        }
        if (event.name == "jobCreate") {
          this.job = new Job();
          this.resetValidation(this.formName);
          this.loading = false;
          this.job.allDay = true;
          this.job.dateStart = event.data;
          this.job.dateEnd = event.data;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* --- Local com toggle de ícones acoplado ao input --- */
.loc-row {
  display: flex;
  align-items: stretch;
  gap: 0;
}

.loc-input {
  flex: 1 1 auto;
  min-width: 0;
  margin-right: 10px;
}

.loc-toggle {
  display: inline-flex;
  align-items: center;
  border-left: none;
  margin-top: 18px;
  gap: 6px;
}

.loc-icon {
  appearance: none;
  border: 1px solid transparent;
  background: transparent;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
}

.loc-icon i {
  font-size: 16px;
}

.loc-icon.active {
  border-color: #e5e7eb;
  box-shadow: 0 1px 4px rgba(16, 24, 40, 0.08);
  font-weight: 600;
}

.loc-icon:focus {
  outline: 2px solid #94a3b8;
  outline-offset: 2px;
}

/* mobile: quebra em 2 linhas */
@media (max-width: 575.98px) {
  .loc-row {
    flex-direction: column;
  }

  .loc-toggle {
    border-left: 1px solid #e7ebf3;
    border-radius: 8px;
    margin-top: 6px;
    align-self: flex-end;
    /* opcional */
  }
}

/* --- Barra de ações moderna --- */
.btn-add {
  margin-top: 38px;
}

.icon-place {
  color: #D98621;
}

.g-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0 12px 16px;
  border: 1px solid #e7ebf3;
  border-radius: 8px;
  margin-top: 10px;
}

.g-actions-left {
  display: flex;
  align-items: center;
  gap: 34px;
}

.g-actions-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.g-actions-right>*:last-child {
  min-width: 100px;
  font-weight: 600;
}

@media (max-width: 575.98px) {
  .g-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .g-actions-left {
    justify-content: space-between;
    width: 100%;
  }

  .g-actions-right {
    margin-left: 0;
    justify-content: stretch;
  }

  .g-actions-right>* {
    width: 100%;
  }
}
</style>
